module.exports = __webpack_public_path__ + "static/img/yy14.c793407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy14.jpg
// module id = xfQC
// module chunks = 1